import api from "./api";

export const loginApi = async ({ username, password }) =>
  api.post("/user-login", { username, password });

